import { AssetType, type EmissionAsset } from '../../types/emissions';

const ALL_ASSET_TYPES = new Set(Object.values(AssetType));

/**
 * Returns asset types that have no assets in the given list.
 * Used to disable those types in the AssetTypeFilter.
 */
export const getDisabledAssetTypes = (assets: EmissionAsset[]): Set<AssetType> => {
  const presentTypes = new Set(assets.map((a) => a.assetType));
  const disabled = new Set<AssetType>();
  for (const type of ALL_ASSET_TYPES) {
    if (!presentTypes.has(type)) {
      disabled.add(type);
    }
  }
  return disabled;
};
